import axiosIns from 'utils/axios'
let epmcore = 'EPM-CORE-SERVICE'

export function formatTree (e) {
  let tree = []
  e.forEach((item) => {
    if (!item.mpttVOList) {
      tree.push({
        label: item.data.name,
        key: item.id,
        rootId: item.rootId,
        companyId: item.data.companyId,
        mpttRootId: item.data.mpttRootId,
        principal: item.data.principal,
        principalIdList: !item.data.principalIdList ? [] : item.data.principalIdList,
        children: []
      })
    } else {
      tree.push({
        label: item.data.name,
        key: item.id,
        rootId: item.rootId,
        companyId: item.data.companyId,
        mpttRootId: item.data.mpttRootId,
        principal: item.data.principal,
        principalIdList: !item.data.principalIdList ? [] : item.data.principalIdList,
        children: formatTree(item.mpttVOList)
      })
    }
  })
  return tree
}

function formatChildren (e) {
  let tree = []
  e.forEach(item => {
    tree.push(Object.assign(item, {
      label: item.name,
      key: item.id
    }))
  })
  return tree
}

export function formatTreeAndPerson (e) {
  let tree = []
  e.forEach((item) => {
    if (!item.mpttVOList && !item.data.employeeVOList) {
      tree.push({
        label: item.data.name,
        key: item.id || item.data.id,
        rootId: item.rootId,
        companyId: item.data.companyId,
        mpttRootId: item.data.mpttRootId,
        principal: item.data.principal,
        children: [],
        disabled: checkDisabled(item)
      })
    } else if (item.mpttVOList && !item.data.employeeVOList) {
      tree.push({
        label: item.data.name,
        key: item.id || item.data.id,
        rootId: item.rootId,
        companyId: item.data.companyId,
        mpttRootId: item.data.mpttRootId,
        principal: item.data.principal,
        children: formatTreeAndPerson(item.mpttVOList),
        disabled: checkDisabled(item)
      })
    } else if (!item.mpttVOList && item.data.employeeVOList) {
      tree.push({
        label: item.data.name,
        key: item.data.id,
        rootId: item.rootId,
        companyId: item.data.companyId,
        mpttRootId: item.data.mpttRootId,
        principal: item.data.principal,
        children: formatChildren(item.data.employeeVOList),
        disabled: checkDisabled(item)
      })
    } else if (item.mpttVOList && item.data.employeeVOList) {
      tree.push({
        label: item.data.name,
        key: item.id,
        rootId: item.rootId,
        companyId: item.data.companyId,
        mpttRootId: item.data.mpttRootId,
        principal: item.data.principal,
        children: formatTreeAndPerson(item.mpttVOList).concat(formatChildren(item.data.employeeVOList)),
        disabled: checkDisabled(item)
      })
    }
  })
  return tree
}

function checkDisabled (e) {
  if (e) return true
  else return false
}

// 获取整棵树
export function getWholeTree () {
  return axiosIns({
    url: `/api/pc/organization/list`,
    method: 'get',
    owner: epmcore
  })
}
//获取整棵树包括人员
export function getTreeAndPerson () {
  return axiosIns({
    url: `/api/pc/organization/listDetail`,
    method: 'get',
    owner: epmcore
  })
}
//更新组织
export function updateTree (data) {
  return axiosIns({
    url: `/api/pc/organization/update`,
    method: 'put',
    owner: epmcore,
    data
  })
}
//删除组织
export function deleteTree (id) {
  return axiosIns({
    url: `/api/pc/organization/${id}`,
    method: 'delete',
    owner: epmcore
  })
}
//新增组织
export function addTree (data) {
  return axiosIns({
    url: `/api/pc/organization/add`,
    method: 'post',
    owner: epmcore,
    data
  })
}
//移动组织
export function moveTree (data) {
  return axiosIns({
    url: `/api/pc/organization/move`,
    method: 'put',
    owner: epmcore,
    data
  })
}
//查看组织详情
export function treeItemList (id) {
  return axiosIns({
    url: `/api/pc/organization/pageOrganizationEmployee`,
    method: 'get',
    owner: epmcore,
    params: id
  })
}
//新增雇员
export function addEmploy (data) {
  return axiosIns({
    url: `/api/pc/employee/add`,
    method: 'post',
    owner: epmcore,
    data
  })
}
//删除雇员
// export function deleteEmploy (data) {
//   return axiosIns({
//     url: `/api/pc/employee/delete`,
//     method: 'delete',
//     owner: epmcore,
//     data
//   })
// }

//删除雇员
export function deleteEmploy (ids) {
  return axiosIns({
    url: `/api/pc/employee/delete/${ids}`,
    method: 'delete',
    owner: epmcore,
  })
}

//更新雇员
export function updateEmploy (data) {
  return axiosIns({
    url: `/api/pc/employee/update`,
    method: 'put',
    owner: epmcore,
    data
  })
}
//分页查询雇员雇员
export function listEmploy (data) {
  return axiosIns({
    url: `/api/pc/employee/page`,
    method: 'get',
    owner: epmcore,
    data
  })
}
//设置雇员所在部门
export function updateEmployeeOrganization (data) {
  return axiosIns({
    url: `/api/pc/employee/updateEmployeeOrganization`,
    method: 'put',
    owner: epmcore,
    data
  })
}

export function dictGet (params) {
  return axiosIns({
    url: `/api/pc/companyDict/getMap`,
    owner: epmcore,
    method: 'get',
    params
  })
}

export function changeStatus (data) {
  return axiosIns({
    url: `/api/pc/employee/changeStatus`,
    owner: epmcore,
    method: 'put',
    data
  })
}

export function sysRolepage () {
  return axiosIns({
    url: `/api/pc/sysRole/page`,
    owner: epmcore,
    method: 'get'
  })
}

export function syncWxWork (id) {
  return axiosIns({
    url: `/api/pc/wxWork/syn`,
    owner: epmcore,
    method: 'post'
  })
}

export function changeMobile (data) {
  return axiosIns({
    url: `/api/pc/employee/changeMobile`,
    owner: epmcore,
    method: 'put',
    data
  })
}

//批量设置汇报管理
export function batchSetEmployeeReportFlag (data) {
  return axiosIns({
    url: `/api/pc/employee/batchSetEmployeeReportRemindFlag`,
    owner: epmcore,
    method: 'put',
    data
  })
}



// WEBPACK FOOTER //
// ./src/views/system-manage/organizational-structure/api.js